// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-buttons .active, .header_menu .active{
    width: 149px;

    padding: 0px 23px 5px 0px;

    left: 0px;

    color: #E9C455;

    border-radius: 0px;
    border-bottom: 2px solid #E9C455;
    border-left: 0px solid #FFF;

    transition: 500ms;
}


.nav-minimal {
    background-color: #fff;

    width: 100%;
    height: 70px;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;

    position: absolute;
    z-index: 999;

    color: #000;
}

.nav-minimal div{
    display: flex;
    align-items: center;
    gap: 10px;

    padding: 0px 10px;
}

.nav-minimal span{
    font-family: 'Inter', sans-serif;;
    font-size: 16px;
    font-weight: 400;
}

.navbar{
    height: 70px;

    padding: 0px 18px;
    position: sticky;
    top: -1px;
    z-index: 998;

    display: flex;
    align-items: center;
    justify-content: normal;

    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);

    overflow: hidden;
}

.navbar::before{
    content: "";

    width: 100%;
    height: 100%;

    position: absolute;

    z-index: -1;
    inset: 0px;

    background-color: #fff;
}

.nav-logo {
    display: flex;
    justify-content: center;
    align-items: center;
}

.nav-logo>img {
    width: 60px;
    height: 60px;

    border-radius: 10px;
}

.nav-buttons {
    background-color: #fff;
}

.nav-buttons>ul{
    display: flex;
    align-items: center;
    gap: 10px;

    padding-left: 2vw;
    padding-right: 5vw;

    list-style: none;
}

.nav-buttons>ul>a{
    font-family: "Inter";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;

    cursor: pointer;

    border-bottom: 3px solid #fff;
}

.nav-buttons>ul>a:hover {
    color: #E9C455 !important;

    border-bottom: 3px solid #E9C455;
}

.nav-infos {
    height: auto;

    display: flex;
    align-content: center;
    justify-content: center;
    gap: 33px;

    position: absolute;
    right: 43px;
}

.nav-infos>div {
    display: flex;
    align-items: center;
    gap: 5px;
}

.navbar>.menu{
    transform: scale(1.5);

    display: none;

    position: absolute;
    right: 20px;

    cursor: pointer;
}



@media screen and (max-width: 1020px) {
    .nav-buttons {
        width: 100%;

        transition: 1s;

        position: absolute;
        z-index: -3;
        left: 0px;
        top: -250%;

        box-shadow: 0 10px 4px 0px rgba(0, 0, 0, 0.33);
    }

    .nav-buttons>ul{
        flex-direction: column;
        align-items: normal;
    }

    .nav-buttons>ul li, a{
        width: fit-content;
    }

    .nav-infos {
        height: 0px;
        width: 100%;

        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0px;

        position: static;
        margin-top: -65px;
    }

    .navbar>.menu{
        display: block;

    }

    .navbar {
        overflow: unset;
    }

    .nav-infos {
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 20px;
    }


    .nav-infos div:nth-child(1) {
        width: 100vw;
        justify-content: center;
    }

    .nav-infos div:nth-child(2), .nav-infos div:nth-child(3) {
        justify-content: center;
    }
}

@media screen and (max-width: 650px) {
    .nav-minimal {
        gap: 5px;
    }

    .nav-minimal span {
        font-size: 2.8vw;
    }

    .nav-buttons {
        position: absolute;
        top: -300%;
    }

    .nav-infos {
        height: auto;

        background-color: #fff;

        transition: 1s;

        position: absolute;
        left: 0px;
        right: 0px;
        top: -100%;
        z-index: -2;

        margin-top: 0px;

    }

    .nav-minimal svg {
        width: 5vw;
    }

    .nav-minimal {
        flex-wrap: wrap;
        height: fit-content;
        column-gap: 20px;
    }


    .nav-minimal div:nth-child(1) {
        width: 100vw;
        justify-content: center;
    }

    .nav-minimal div:nth-child(2), .nav-minimal div:nth-child(3) {
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/utils/components/navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;;IAEZ,yBAAyB;;IAEzB,SAAS;;IAET,cAAc;;IAEd,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;;IAE3B,iBAAiB;AACrB;;;AAGA;IACI,sBAAsB;;IAEtB,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;;IAET,kBAAkB;IAClB,YAAY;;IAEZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;;IAEZ,iBAAiB;IAGjB,gBAAgB;IAChB,SAAS;IACT,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,yCAAyC;;IAEzC,gBAAgB;AACpB;;AAEA;IACI,WAAW;;IAEX,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,WAAW;IACX,UAAU;;IAEV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,iBAAiB;IACjB,kBAAkB;;IAElB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;IAEhB,eAAe;;IAEf,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;;IAEzB,gCAAgC;AACpC;;AAEA;IACI,YAAY;;IAEZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;;IAET,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;;IAErB,aAAa;;IAEb,kBAAkB;IAClB,WAAW;;IAEX,eAAe;AACnB;;;;AAIA;IACI;QACI,WAAW;;QAEX,cAAc;;QAEd,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,UAAU;;QAEV,8CAA8C;IAClD;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,WAAW;;QAEX,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;;QAER,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,cAAc;;IAElB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;;;IAGA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,YAAY;;QAEZ,sBAAsB;;QAEtB,cAAc;;QAEd,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,UAAU;QACV,WAAW;;QAEX,eAAe;;IAEnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,gBAAgB;IACpB;;;IAGA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".nav-buttons .active, .header_menu .active{\n    width: 149px;\n\n    padding: 0px 23px 5px 0px;\n\n    left: 0px;\n\n    color: #E9C455;\n\n    border-radius: 0px;\n    border-bottom: 2px solid #E9C455;\n    border-left: 0px solid #FFF;\n\n    transition: 500ms;\n}\n\n\n.nav-minimal {\n    background-color: #fff;\n\n    width: 100%;\n    height: 70px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 40px;\n\n    position: absolute;\n    z-index: 999;\n\n    color: #000;\n}\n\n.nav-minimal div{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    padding: 0px 10px;\n}\n\n.nav-minimal span{\n    font-family: 'Inter', sans-serif;;\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.navbar{\n    height: 70px;\n\n    padding: 0px 18px;\n\n    position: -webkit-sticky;\n    position: sticky;\n    top: -1px;\n    z-index: 998;\n\n    display: flex;\n    align-items: center;\n    justify-content: normal;\n\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n\n    overflow: hidden;\n}\n\n.navbar::before{\n    content: \"\";\n\n    width: 100%;\n    height: 100%;\n\n    position: absolute;\n\n    z-index: -1;\n    inset: 0px;\n\n    background-color: #fff;\n}\n\n.nav-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.nav-logo>img {\n    width: 60px;\n    height: 60px;\n\n    border-radius: 10px;\n}\n\n.nav-buttons {\n    background-color: #fff;\n}\n\n.nav-buttons>ul{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    padding-left: 2vw;\n    padding-right: 5vw;\n\n    list-style: none;\n}\n\n.nav-buttons>ul>a{\n    font-family: \"Inter\";\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n\n    cursor: pointer;\n\n    border-bottom: 3px solid #fff;\n}\n\n.nav-buttons>ul>a:hover {\n    color: #E9C455 !important;\n\n    border-bottom: 3px solid #E9C455;\n}\n\n.nav-infos {\n    height: auto;\n\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    gap: 33px;\n\n    position: absolute;\n    right: 43px;\n}\n\n.nav-infos>div {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.navbar>.menu{\n    transform: scale(1.5);\n\n    display: none;\n\n    position: absolute;\n    right: 20px;\n\n    cursor: pointer;\n}\n\n\n\n@media screen and (max-width: 1020px) {\n    .nav-buttons {\n        width: 100%;\n\n        transition: 1s;\n\n        position: absolute;\n        z-index: -3;\n        left: 0px;\n        top: -250%;\n\n        box-shadow: 0 10px 4px 0px rgba(0, 0, 0, 0.33);\n    }\n\n    .nav-buttons>ul{\n        flex-direction: column;\n        align-items: normal;\n    }\n\n    .nav-buttons>ul li, a{\n        width: fit-content;\n    }\n\n    .nav-infos {\n        height: 0px;\n        width: 100%;\n\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 0px;\n\n        position: static;\n        margin-top: -65px;\n    }\n\n    .navbar>.menu{\n        display: block;\n\n    }\n\n    .navbar {\n        overflow: unset;\n    }\n\n    .nav-infos {\n        flex-direction: row;\n        flex-wrap: wrap;\n        column-gap: 20px;\n    }\n\n\n    .nav-infos div:nth-child(1) {\n        width: 100vw;\n        justify-content: center;\n    }\n\n    .nav-infos div:nth-child(2), .nav-infos div:nth-child(3) {\n        justify-content: center;\n    }\n}\n\n@media screen and (max-width: 650px) {\n    .nav-minimal {\n        gap: 5px;\n    }\n\n    .nav-minimal span {\n        font-size: 2.8vw;\n    }\n\n    .nav-buttons {\n        position: absolute;\n        top: -300%;\n    }\n\n    .nav-infos {\n        height: auto;\n\n        background-color: #fff;\n\n        transition: 1s;\n\n        position: absolute;\n        left: 0px;\n        right: 0px;\n        top: -100%;\n        z-index: -2;\n\n        margin-top: 0px;\n\n    }\n\n    .nav-minimal svg {\n        width: 5vw;\n    }\n\n    .nav-minimal {\n        flex-wrap: wrap;\n        height: fit-content;\n        column-gap: 20px;\n    }\n\n\n    .nav-minimal div:nth-child(1) {\n        width: 100vw;\n        justify-content: center;\n    }\n\n    .nav-minimal div:nth-child(2), .nav-minimal div:nth-child(3) {\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
